import { Box } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import TableComponent from 'UiKit/table-component';
import PreviewImage from 'UiKit/preview-image';

import { TableSkeleton } from 'View/report-attendance/component/skeleton';
import { tableList } from 'View/report-attendance-host-detail/section/table/const';
import LivestreamDetailModal from 'View/report-attendance-host-detail/component/livestream-detail-modal';
import { useReportAttendanceHostDetailState } from 'View/report-attendance-host-detail/state';

import styles from './styles.module.css';

const Table = ({ data, isFetching, t }) => {
  const { filterState, updateFilterState, state, updateState } = useReportAttendanceHostDetailState();

  const onChangePagination = (page) => updateFilterState({ page });

  const handleClosePreview = () =>
    updateState({
      isOpenImagePreview: false,
      selectedImagePreview: [],
      ...(state.imagePreviewPreviousModal ? { [state.imagePreviewPreviousModal]: true } : {}),
      imagePreviewPreviousModal: null,
    });

  const reportData = data?.reports?.map((item) => ({
    ...item,
    hostName: data?.hostName,
  }));

  return (
    <Box className={styles['table__container']}>
      <Box className={styles['table__wrapper']}>
        <Condition statement={!isFetching} fallback={<TableSkeleton />}>
          <TableComponent
            tableName="table__report-host-detail-attendance"
            columns={tableList({ t })}
            dataSource={reportData || []}
            isDataExist={data?.isDataExist}
            verticalAlignBody={'top'}
            paddingBodyBox={'0px'}
            rowHeight={'100%'}
            maxTableHeight="calc(100vh - 346px)"
            maxTableBodyHeight="calc(100vh - 445px)"
            tableComponentHeight="calc(100vh - 274px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: data?.totalData,
              onChange: onChangePagination,
              isLoading: isFetching,
            }}
          />
        </Condition>
      </Box>

      <LivestreamDetailModal />
      <PreviewImage images={state?.selectedImagePreview} isOpen={state?.isOpenImagePreview} onClose={handleClosePreview} initialIndex={0} />
    </Box>
  );
};

export default Table;
